<div class="container sms005">
  <!-- ヘッダーエリア -->
  <app-header></app-header>

  <!-- メインエリア -->
  <div class="main-area">

    <!-- コンテンツエリア -->
    <div class="content-area" [style.width]="windowsWidth">

      <!-- フォームエリア -->
      <form class="sms-form">
        <div [formGroup]="smsForm">

          <br>
          <!-- 文言 -->
          <div>
            <mat-label class="message">{{lblName}}</mat-label>
          </div>
          <br>
          <div>
            <mat-label class="message">{{lblMessage01}}</mat-label>
          </div>
          <br>

          <mat-label class="message">{{lblMessage02}}</mat-label>
          <div>
            <fieldset class="grid-frame">
              <mat-radio-group formControlName="rdoYatinYmKbn" class="radio-line" tabindex="1">
                <mat-radio-button class="grid-yatin-radio"
                                  name="rdoYatinYmKbn"
                                  *ngFor="let item of initVo; let i = index"
                                  [checked]="i === 0"
                                  [value]="item.id">
                    <div class="grid-row">
                      <mat-label class="grid-yyyymm">{{item.yatinYm}}</mat-label>
                      <mat-label class="grid-kingaku">{{item.seikyuGaku}}</mat-label>
                    </div>
                </mat-radio-button>

                <div class="grid-row-goukei">
                  <mat-label [style]="'width:28px;'">&nbsp;</mat-label>
                  <mat-label class="grid-yyyymm">{{lblGokei}}</mat-label>
                  <mat-label class="grid-kingaku">{{lblGokeiGaku}}</mat-label>
                </div>
                <div class="grid-row-goukei">
                  <mat-label [style]="'width:28px;'">&nbsp;</mat-label>
                  <mat-label class="grid-yyyymm">&nbsp;</mat-label>
                  <mat-label class="grid-kingaku">{{lblMessage03}}</mat-label>
                </div>
              </mat-radio-group>
            </fieldset>
          </div>

          <!-- 文言 -->
          <div>
            <mat-label class="message">{{lblShutokuDate}}</mat-label>
          </div>
          <br>
          <br>

          <mat-label class="message">{{lblMessage04}}</mat-label>
          <div>
            <fieldset class="grid-koza">
              <div class="grid-row">
                <mat-label class="grid-koza-bank">{{lblBankName}}</mat-label>
                <mat-label class="grid-koza-siten">{{lblTenpoName}}</mat-label>
              </div>
              <div class="grid-row">
                <mat-label class="grid-koza-shbt">{{lblKozaShbt}}</mat-label>
                <mat-label class="grid-koza-no">{{lblKozaNo}}</mat-label>
              </div>
            </fieldset>
          </div>
          <br>

          <!-- ボタン -->
          <div class="button-area">
            <button type="submit" mat-raised-button [disabled]="!isEnableBtnDetail" (click)="detailClick()" tabindex="2">{{lblBtnDetail}}</button>
          </div>

        </div>
      </form>

    </div>
  </div>

  <!-- フッターエリア -->
  <div class="footer-area">
    <div class="img-area">
      <img class="img-logo" src="assets/images/footer_ofi_copyright.png" />
    </div>
    <div class="data-operation-button-area">
      <button type="button" mat-raised-button (click)="backClick()" accesskey="q" tabindex="3">{{lblBtnMenu}}</button>
    </div>
  </div>

</div>
